import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import AccountCircle from '@material-ui/icons/AccountCircle';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Menu from '@material-ui/icons/Menu';
import { Row } from 'components/UI/Row';
import { setAppMenuOpen } from 'components/AppMenu/appMenu';

const SimpleNavBar: FC<{ showBackBtn?: boolean; title?: string }> = ({ showBackBtn, title }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <AppBar position="sticky">
      <Toolbar className="navColor" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Row justifyContent="space-between" alignItems="center" height="64px">
          {!showBackBtn ? (
            <IconButton aria-label="menu" color="inherit" onClick={() => dispatch(setAppMenuOpen(true))}>
              <Menu />
            </IconButton>
          ) : (
            <IconButton aria-label="back" color="inherit" onClick={() => history.goBack()}>
              <ArrowBackIosIcon />
            </IconButton>
          )}
          <span>{title}</span>
          <IconButton aria-label="profile" color="inherit" onClick={() => history.push('/profile')}>
            <AccountCircle />
          </IconButton>
        </Row>
      </Toolbar>
    </AppBar>
  );
};

export { SimpleNavBar };
